<template>
    <!-- `size` is the star glyph's font-size (any CSS length, or 'inherit' to match the surrounding text — ed, 2026-09-30:
         "/skills … size them to match the font of the user's name in that list") -->
    <span class="csk-stars" :class="{ 'csk-stars--disabled': disabled, 'csk-stars--filter': filter }" :style="{ fontSize: size }" :data-testid="testid" role="group" :aria-label="label">
        <!-- #1953 — the filter's ALL comes first; picking N stars hides everyone below N, unrated included -->
        <a v-if="filter" href="javascript:void(0)" class="csk-all" :class="{ 'csk-all--on': !value }"
           @click="pick(0)" :data-testid="testid + '-all'" title="Everyone, rated or not">ALL</a>
        <a v-for="n in 5" :key="n" href="javascript:void(0)" class="csk-star" :class="{ 'csk-star--on': value >= n }"
           @click="pick(n)" :data-testid="testid + '-' + n" :title="filter ? (n + ' stars and up') : (n + (n === 1 ? ' star' : ' stars'))">&#9733;</a>
    </span>
</template>

<script>
    // #1953 — the 0–5 star control, one component for the three places it appears:
    //   · the employee's Skills tab (per skill, individual edit)
    //   · the bulk skill window (per employee, one skill)
    //   · the assign page filter (ALL, then 1–5 — `filter` mode)
    // `value` is null/0 (unrated / ALL) or 1–5. Clicking the star that is already
    // the value clears it (rating mode) — that is the "0" ed's spec allows — while in
    // filter mode the same click is a no-op because ALL is its own button.
    export default {
        name: 'SkillStars',
        props: {
            value: { type: Number, default: 0 },
            disabled: { type: Boolean, default: false },
            filter: { type: Boolean, default: false },
            testid: { type: String, default: 'skill-stars' },
            label: { type: String, default: 'Stars' },
            size: { type: String, default: '16px' },
        },
        methods: {
            pick(n) {
                if (this.disabled) return;
                const next = (!this.filter && n === this.value) ? 0 : n;
                if (next !== (this.value || 0)) this.$emit('input', next);
            },
        },
    };
</script>

<style scoped>
    .csk-stars { display: inline-flex; align-items: center; gap: 1px; white-space: nowrap; line-height: 1; vertical-align: middle; }
    .csk-star { font-size: 1em; color: #c9c9c9; text-decoration: none; padding: 0 1px; }   /* 1em = the control's `size` */
    .csk-star--on { color: #f5b301; }
    .csk-stars:not(.csk-stars--disabled) .csk-star:hover { color: #e0a200; }
    .csk-stars--disabled .csk-star { cursor: default; opacity: .6; }
    .csk-all { font-size: 11px; font-weight: bold; margin-right: 4px; padding: 1px 5px; border-radius: 3px; color: #555; background: #eee; text-decoration: none; }
    .csk-all--on { color: #fff; background: #55a2a2; }
    .csk-stars--filter .csk-star { font-size: 1.15em; }
</style>
